<template>

  <div class="hover:shadow-xl ">
    <div
        class="w-full rounded-t-md items-center break-normal justify-between p-6 space-x-6 bg-gradient-to-r from-green-200 to-blue-200 cursor-pointer"
        @click="goToRoom(modelValue.room_key)">
      <div>
        <div class="mb-2"><h3 class="text-gray-900  font-bold text-lg truncate">
          {{ modelValue.room_name }}</h3></div>
        <div class="mb-2 space-x-2">
          <span v-if="modelValue.team" class=" px-2 py-0.5 text-blue-800 text-xs font-medium bg-blue-100 rounded-full"> Team Room</span>
          <span v-if="!modelValue.team" class=" px-2 py-0.5 text-orange-800 text-xs font-medium bg-orange-100 rounded-full"> Public Room </span>
        </div>
        <p class="mt-1 text-gray-500 text-sm truncate" v-if="modelValue.team"> Team : {{ modelValue.team.name }} </p>
        <p class="mt-1 text-gray-500 text-sm truncate" v-else>Public Room</p>
        <p class="mt-1 text-gray-500 text-sm truncate">Created by: {{ modelValue.created_by.name }}</p></div>
    </div>
    <div>
      <div class="-mt-px flex divide-x divide-gray-100">
        <button v-if="showConfig" @click="$emit('deleting',modelValue.id)"
                class="flex-1 justify-center items-center flex">

          <TrashIcon class="hover:text-red-600 h-5 flex-shrink-0 text-gray-700 w-full"></TrashIcon>

        </button>
        <button v-if="showConfig" class="flex-1 justify-center items-center flex"><!---->

          <CogIcon @click="$emit('config',{room_id: modelValue.room_key, room_name: modelValue.room_name})"
                   class="hover:text-blue-400 w-5 h-5 flex-shrink-0 text-gray-700 w-full"></CogIcon>

          <input type="hidden" id="roomOp5Ymb8HfqARjtTB" value="https://staging.agilesuite.io/rooms/Op5Ymb8HfqARjtTB">
        </button>

        <button @click="info(modelValue.room_key)"
                class="flex-1 py-3 justify-center items-center flex">

          <LinkIcon class="hover:text-blue-400 w-5 h-5 flex-shrink-0 text-gray-700 w-full"></LinkIcon>

          <input
              type="hidden"
              :id="'room' + modelValue.room_key"
              :value="getLink(modelValue.room_key)"
          />
        </button>
      </div>
    </div>
  </div>

</template>

<script>

import {CogIcon, LinkIcon, TrashIcon, LoginIcon} from '@heroicons/vue/outline'

import {defineComponent, ref} from "vue";
import {message} from "ant-design-vue";
import Button from "@/Jetstream/Button";

export default defineComponent({
  props: {
    modelValue: {},
    showConfig: {
      default: true
    }
  },
  emits: ['deleting', 'config', 'deleted'],
  components: {
    Button,
    CogIcon, LinkIcon, TrashIcon, LoginIcon
  },
  methods: {
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#room" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    goToRoom(roomKey) {
      this.$inertia.visit(route("planning-rooms.accessRoom", {id: roomKey}), {
        preserveState: false
      })
    },
    deleteRoom(roomId) {

      if (confirm('Are you sure?')) {
        let app = this;
        axios
            .delete(route("planning-rooms.delete", {id: roomId}))
            .then((response) => {
              if (response.data.success) {
                message.success("Successfully deleted.");
                app.$emit('deleted', true);
              } else {
                message.error(response.data.message);
              }

            })
            .catch((error) => {
              message.error("Oops, unable to delete.");
              console.log(error);
            });
      }
    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/rooms/' + id : 'https://agilesuite.io/rooms/' + id;
    }
  },
  setup() {
    return {}
  },
});
</script>
